<app-service-detail>
    <div class="row w-100 m-0 position-relative">
        <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
        </app-variables-tabs>
        <app-list-grid *ngIf="!hideList"
                       [items]="costs"
                       [determinantMapById]="determinantMapById"
                       [baseUrl]="baseUrl"
                       [toggleIcons]="false"
                       [navigationEdit]="false"
                       [expanded]="true"
                       (updateFunction)="updateCost($event)"
                       (deleteFunction)="deleteCost($event)"
                       (editFunction)="loadCost($event)"
                       (filterBy)="onNewFilterBy($event)"
                       class="col-md-12 px-md-5 ml-auto"
                       headingText="Costs available in the service"
                       [elementsNumber]="elementsNumber"
                       createNewText1Part="Select an existing cost or click on"
                       createNewText2Part="to create a new cost">
            <button (click)="loadCost(false)"
               placement="left"
               aria-hidden="true"
               class="btn btn-sm btn-primary mr-1">{{ 'Add' | translate }}</button>
        </app-list-grid>

        <div *ngIf="showEdit || showAdd"
             class="layer half-layer col px-3"
             [ngStyle]="style"
             mwlResizable
             [enableGhostResize]="true"
             [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
             (resizeEnd)="onResizeEnd($event)"
             style="min-height:calc(100vh - 9.1rem);">
            <cost-edit [cost]="cost"
                       [serviceId]="serviceId"
                       [determinantMapById]="determinantMapById"
                       [costView]="costView"
                       (formSubmit)="closeSlider()"
                       (editCancel)="closeLayers()"
                       class="w-100"></cost-edit>
        </div>
        <div class="shadow"></div>
        <div class="col-md-12">
            <tab-menu *ngIf="hideList" [items]="costs" [baseUrl]="baseUrl"></tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
